import { FaUser } from 'react-icons/fa';
import { showPicture } from '../../utils/commonFunctions';

const PictureViewRowDiv = ({
  profilePicture,
  username,
}: {
  profilePicture: string | null;
  username: string;
}) => {
  // rendering associate picture view component here
  return (
    <div className='flex items-center justify-center'>
      {profilePicture ? (
        <div className='size-10 rounded-full overflow-hidden'>
          <img
            className='w-full h-full object-cover'
            src={showPicture(profilePicture)}
            alt={`avatar of ${username}`}
          />
        </div>
      ) : (
        <div className='flex items-center justify-center bg-base-light-gray size-10 rounded-full'>
          <FaUser className='size-6 text-gray-300' />
        </div>
      )}
    </div>
  );
};

export default PictureViewRowDiv;
